import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { HERO_SLIDES } from "@/data/catalog";

export const HeroCarousel = () => {
  const { t } = useTranslation();
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % HERO_SLIDES.length), 6000);
    return () => clearInterval(id);
  }, []);
  const s = HERO_SLIDES[i];
  return (
    <section data-testid="hero" className="nv-grain relative overflow-hidden bg-black text-white">
      <div className="nv-container grid min-h-[560px] items-center gap-10 py-14 lg:grid-cols-2">
        <div key={s.id} className="nv-fade-up relative z-10 order-2 lg:order-1">
          <p className="nv-eyebrow !text-[#c6ff00]">NINJAVITY</p>
          <h1 className="mt-4 font-display text-4xl font-bold leading-[1.02] sm:text-5xl lg:text-6xl">{t(`hero.${s.id}.title`)}</h1>
          <p className="mt-5 max-w-lg text-base text-white/70 md:text-lg">{t(`hero.${s.id}.sub`)}</p>
          <Link to={s.link} data-testid="hero-cta" className="nv-btn-lime mt-8">{t(`hero.${s.id}.cta`)} <ArrowRight size={16} /></Link>
          <div className="mt-10 flex gap-2">
            {HERO_SLIDES.map((h, k) => (
              <button key={h.id} data-testid={`hero-dot-${k}`} onClick={() => setI(k)} aria-label={h.id} className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-10 bg-[#c6ff00]" : "w-4 bg-white/30 hover:bg-white/60"}`} />
            ))}
          </div>
        </div>
        <div className="relative order-1 lg:order-2">
          <div className="absolute -inset-10 rounded-full bg-[#c6ff00]/20 blur-3xl" />
          <div key={s.id + "img"} className="nv-fade-up relative overflow-hidden rounded-3xl ring-1 ring-white/10">
            <img src={s.img} alt="" className="aspect-[4/3] w-full object-cover" />
          </div>
          <img src="/brand/icon.png" alt="" className="absolute -bottom-6 -left-6 hidden h-24 w-24 rotate-[-12deg] drop-shadow-2xl lg:block" />
        </div>
      </div>
    </section>
  );
};
